// Array.from polyfill (https://gist.github.com/brettz9/4212262)
// @requires polyfill: Array.prototype.slice fix {@link https://gist.github.com/brettz9/6093105}

if (!Array.from) {
    Array.from = (object) => {
        return [].slice.call(object);
    };
}
